import { useMemo } from 'react';

import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';

import { useRewardTiers } from '../queries/loyalty.queries';

export const useRewardTierApplied = () => {
  const isRewardsTiersEnabled = useFlag(LaunchDarklyFlag.ENABLE_REWARDS_TIERS) as boolean;

  const { data: rewardTiers, isFetched } = useRewardTiers();
  const appliedOffers = useAppSelector(selectors.loyalty.selectAppliedOffers);

  const rewardTierApplied = useMemo(() => {
    return rewardTiers?.find(tier => appliedOffers.some(offer => offer.id === tier.id));
  }, [rewardTiers, appliedOffers]);

  return {
    rewardTierApplied,
    isRewardTierApplied: !!rewardTierApplied,
    isFetched,
    isRewardsTiersEnabled,
  };
};
